import { z } from "zod";

const sealProXDesiredPlcSettingsSchema = z.object({
	glueTankTemperature: z.number(),
	glueTankIdleTemperature: z.number(),
	glueHoseTemperature: z.number(),
	glueNozzleTemperature: z.number(),
	glueIdleTime: z.number(),
	maxTimeForPackNetResponse: z.number(),
	consecutiveInductFailuresBeforeError: z.number(),
});

const sealProXMachineConfigurationIdentifiers = ["Unknown", "XF1"] as const;
const sealProXMachineConfigurationIdentifierSchema = z.enum(sealProXMachineConfigurationIdentifiers);

const sealProXPlcSettings = z.object({
	glueTankTemperature: z.number(),
	glueTankIdleTemperature: z.number(),
	glueHoseTemperature: z.number(),
	glueNozzleTemperature: z.number(),
	glueIdleTime: z.number(),
	maxTimeForPackNetResponse: z.number(),
	consecutiveInductFailuresBeforeError: z.number(),
	machineConfiguration: sealProXMachineConfigurationIdentifierSchema.default("Unknown"),
});

const baseMachineConfigurationSchema = z.object({
	id: z.string(),
	tenantId: z.string().optional(),
	iotEdgeDeviceId: z.string().nullish(),
	iotEdgeModuleId: z.string().nullish(),
	edgeModuleVersion: z.string().nullish(),
	isUpgraded: z.boolean().optional(),
	configurationVersion: z.number().optional(),
	edgeModuleVersionLastUpdated: z.string().optional(),
	iotHubName: z.string().nullish(),
	alias: z.string().optional(),
	description: z.string().optional(),
	machineType: z.string().optional(),
	ipOrDnsName: z.string().optional(),
	port: z.number().optional(),
	assetId: z.string().optional(),
	plcVersion: z.string().nullish(),
	sessionNumber: z.number().optional(),
	sessionNumberTimeStamp: z.string().optional(),
	lastSequenceNumber: z.number().optional(),
	lastProofOfLifeTimeStamp: z.string().optional(),
	status: z.string().optional(),
	productionStatus: z.string().optional(),
	isReadyForWork: z.boolean().optional(),
	packMlMode: z.string().optional(),
	packMlState: z.string().optional(),
	lastStopReasonSequenceNumber: z.number().optional(),
	securePrintConfiguration: { delayLabelRetrieval: false },
	userName: z.string().optional(),
	messageId: z.string().optional(),
});

export const sealProXMachineSchema = baseMachineConfigurationSchema.extend({
	unit: z.string().optional(),
	desiredPlcSettings: sealProXDesiredPlcSettingsSchema,
	plcSettings: sealProXPlcSettings.optional(),
});

export type SealProXDesiredPlcSettings = z.infer<typeof sealProXDesiredPlcSettingsSchema>;
export type SealProXMachineConfigurationIdentifier = z.infer<typeof sealProXMachineConfigurationIdentifierSchema>;
export type SealProXPlcSettings = z.infer<typeof sealProXPlcSettings>;
export type SealProXMachine = z.infer<typeof sealProXMachineSchema>;
